import { render, staticRenderFns } from "./rating-item.vue?vue&type=template&id=38c2d0d0&"
import script from "./rating-item.vue?vue&type=script&lang=ts&"
export * from "./rating-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c2d0d0')) {
      api.createRecord('38c2d0d0', component.options)
    } else {
      api.reload('38c2d0d0', component.options)
    }
    module.hot.accept("./rating-item.vue?vue&type=template&id=38c2d0d0&", function () {
      api.rerender('38c2d0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/rating/rating-item.vue"
export default component.exports